import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.alert');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-alert',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.alert/view.scss */
.wiz-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.wiz-modal .modal {
  display: contents;
}
.wiz-modal .modal-content {
  width: 100%;
  min-width: 300px;
  max-width: 400px;
  background: linear-gradient(145deg, #1e293b, #0f172a);
  border: 1px solid #334155;
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
}
.wiz-modal .modal-body {
  padding: 32px 24px;
  text-align: center;
}
.wiz-modal .icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.wiz-modal .icon-wrapper.icon-success {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}
.wiz-modal .icon-wrapper.icon-error {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}
.wiz-modal .icon-wrapper.icon-warning {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}
.wiz-modal .icon-wrapper.icon-info {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}
.wiz-modal .modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 12px;
}
.wiz-modal .modal-message {
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.6;
  margin-bottom: 24px;
}
.wiz-modal .modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.wiz-modal .modal-buttons button {
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  min-width: 100px;
}
.wiz-modal .modal-buttons button:active {
  transform: scale(0.96);
}
.wiz-modal .modal-buttons .btn-cancel {
  background: #334155;
  color: #94a3b8;
}
.wiz-modal .modal-buttons .btn-cancel:hover {
  background: #475569;
  color: #f1f5f9;
}
.wiz-modal .modal-buttons .btn-action {
  color: white;
}
.wiz-modal .modal-buttons .btn-action.btn-success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.4);
}
.wiz-modal .modal-buttons .btn-action.btn-success:hover {
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.5);
}
.wiz-modal .modal-buttons .btn-action.btn-error {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.4);
}
.wiz-modal .modal-buttons .btn-action.btn-error:hover {
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.5);
}
.wiz-modal .modal-buttons .btn-action.btn-warning {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.4);
}
.wiz-modal .modal-buttons .btn-action.btn-warning:hover {
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}
.wiz-modal .modal-buttons .btn-action.btn-info {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.4);
}
.wiz-modal .modal-buttons .btn-action.btn-info:hover {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
}`],
})
export class PortalSeasonAlertComponent implements OnInit {
    @Input() model: any = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.alert;
    }

    public async ngOnInit() {
    }
}

export default PortalSeasonAlertComponent;